import { render, staticRenderFns } from "./BuyCrypto.vue?vue&type=template&id=438709bd&scoped=true"
import script from "./BuyCrypto.vue?vue&type=script&lang=js"
export * from "./BuyCrypto.vue?vue&type=script&lang=js"
import style0 from "./BuyCrypto.vue?vue&type=style&index=0&id=438709bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438709bd",
  null
  
)

export default component.exports